import { render, staticRenderFns } from "./RmaHistory.vue?vue&type=template&id=07d50999&"
import script from "./RmaHistory.vue?vue&type=script&lang=js&"
export * from "./RmaHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports